import { useEffect, useState } from "react";
import { useAppSelector } from "../../store/types";
import {
  getTranslatedTextSelector,
  getTranslatedStatusSelector,
} from "../../selectors/settingsSelector";
import type { ReactNode } from "react";

export interface TranslationEntry {
  sourceText: string;
  translatedText: string;
}

interface Props {
  children?: ReactNode;
}

const SbuxTranslate = ({ children }: Props): ReactNode => {
  const translatedText = useAppSelector(getTranslatedTextSelector);
  const translatedStatus = useAppSelector(getTranslatedStatusSelector);

  const [translatedData, setTranslatedData] = useState<TranslationEntry[]>([]);

  useEffect(() => {
    if (translatedStatus === "success") {
      setTranslatedData(translatedText as TranslationEntry[]);
    }
  }, [translatedStatus, translatedText]);

  const translate = (text: ReactNode): ReactNode => {
    const textValue = Array.isArray(text) ? text[1] : text;
    if (
      textValue &&
      typeof textValue === "string" &&
      translatedData.length > 0
    ) {
      const result = translatedData.find((f) => f.sourceText === textValue);
      return result?.translatedText ? result.translatedText : textValue;
    } else {
      return textValue ?? null;
    }
  };

  return translate(children);
};

export default SbuxTranslate;
